var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartsGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    width: 12,
    height: 12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 10,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAMAAAC38k/IAAAAAXNSR0IB2cksfwAAAEJQTFRFFx0nAAAAFxsnGRkhGB0nGBwnJCQkFx0mGB4nAAAAGR8oFxcuGB0oGRsoGCAoGB0nGB0nGB4mGRwnGhoaGR0nGB0n//jmTAAAABZ0Uk5TYgBCH/++B1dUAVMLYGcgqN2SSAql6wQ+KikAAAA+SURBVHicjcfBCoAgFAXRO7wnIS6k///SNKXQcu0sBg5CM7rh7YOJiQDUH7HouAYS3AumVDeQ33dZk+OnVg89OhpasvqCUAAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartsGraph);
export default __webpack_public_path__ + "static/media/charts-graph.7af6a13178d53811c13a0039d39db647.svg";
export { ForwardRef as ReactComponent };